export function trimLeadingSlashes(str: string): string {
	return str?.replace(/^\/+/, '');
}

export function nullSafeJoin(values: any, separator: string = ' '): string {
	if (!Array.isArray(values)) {
		return values;
	}
	return values
		.filter(value => value !== null && value !== undefined)
		.join(separator);
}

export function isEmptyOrUndefined(value: string | undefined): boolean {
	if (isNullOrUndefined(value)) {
		return true;
	} else {
		return (value as string).length <= 0;
	}
}

export function coerceToInt(value: string | number | null | undefined): number {
	if (typeof value === 'string') {
		return parseInt(value);
	}

	if (typeof value === 'number') {
		return value;
	}

	return 0;
}

export function isNullOrUndefined(value: any): boolean {
	return value === null || value === undefined;
}

export function trimFirstToken(source: string, token: string): string {
	return source.replace(token, '');
}

export function parseIntIfPresent(value: string | null | undefined, radix?: number): number | undefined {
	if (typeof value === 'string') {
		return parseInt(value, radix);
	} else {
		return undefined;
	}
}

export function distinctNonBlankStringsOf(values: (string | null | undefined)[]): string[] {
	const strings = values
		.filter(item => typeof item === 'string' && item !== '') as string[];
	return [...new Set(strings)];
}

export function toDisplayText(value: unknown, locale: string): string {
	if (typeof value === 'string') {
		return value;
	}

	if (typeof value === 'number') {
		return value.toLocaleString(locale);
	}

	if (value instanceof Date) {
		return value.toLocaleDateString(locale);
	}

	return JSON.stringify(value);
}

export function normalize(str: any): string {
	return str?.toString()?.toLocaleLowerCase()?.trim() ?? '';
}
